@if (error) {
	<admonition-box class="mb2" type="error" [content]="error" header="Error" [closable]="true" (close)="error = ''"></admonition-box>
}

<div fxLayout="column" fxLayoutGap="16px" style="height: 450px">
	<p class="h2">{{ headline }}</p>
	<div>
		{{ description }}
	</div>
	<mat-list fxFlex>
		@for (v of values; track v; let i = $index) {
			<mat-list-item>
				<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" style="width: 100%">
					<span fxFlex>{{ v }}</span>
					<button mat-icon-button (click)="deleteValue(i)" fxFlex="nogrow">
						<mat-icon>clear</mat-icon>
					</button>
				</div>
			</mat-list-item>
		}
	</mat-list>
	<div fxLayout="row" style="width: 100%; height: auto" fxLayoutGap="8px">
		<mat-form-field fxFlex="1 0 0" appearance="outline">
			@if (inputData?.label) {
				<mat-label>{{ inputData?.label }}</mat-label>
			}

			@if (inputData?.hint) {
				<mat-hint>User to add in CRN format</mat-hint>
			}
			<input matInput [placeholder]="inputData?.placeholder || ''" #valueForm />
		</mat-form-field>
		<button mat-raised-button color="primary" (click)="addValue(valueForm.value)" style="height: calc(100% - 32px)">Add</button>
	</div>
	<div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
		@if (isUpdating) {
			<mat-spinner [diameter]="32"></mat-spinner>
		}
		<button mat-raised-button (click)="close(undefined)" [disabled]="isUpdating">Cancel</button>
		<button mat-raised-button color="primary" (click)="update()" [disabled]="isUpdating">Update</button>
	</div>
</div>
